import React from "react";
import ComponentCard from "../../../components/common/ComponentCard";
import SocialListComponent from "../../../components/slider/SocialListComponent";
import PageMeta from "../../../components/common/PageMeta";

const SocialsList = () => {

    return (
        <>
            <PageMeta title="Danh sách socials" description="Danh sách socials" />
            <div className="space-y-6">
                <ComponentCard title="">
                    <SocialListComponent />
                </ComponentCard>
            </div>
        </>
    );
};

export default SocialsList;
